import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["clsPrefix", "title", "content"];

/**
 * 目前popover是基于tooltips实现
 * PopoverProps 是继承于tooltips中 AbstractTooltipProps
 * 同时存在独立属性
 * title?: React.ReactNode | RenderFunction;
 * 和
 * content?: React.ReactNode | RenderFunction;
 */
import * as React from 'react';
import Tooltip from '../../wui-tooltip/src';
import { getRenderPropValue, getTransitionName } from "../../wui-core/src/utils/createAntdUtils";
import { prefix } from "../../wui-core/src/index.js";
var Popover = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$clsPrefix = _ref.clsPrefix,
      clsPrefix = _ref$clsPrefix === void 0 ? "".concat(prefix, "-popover") : _ref$clsPrefix,
      title = _ref.title,
      content = _ref.content,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var getOverlay = function getOverlay(clsPrefix) {
    if (!title && !content) return null;
    return /*#__PURE__*/React.createElement(React.Fragment, null, title && /*#__PURE__*/React.createElement("div", {
      className: "".concat(clsPrefix, "-title")
    }, getRenderPropValue(title)), /*#__PURE__*/React.createElement("div", {
      className: "".concat(clsPrefix, "-inner-content")
    }, getRenderPropValue(content)));
  };

  return /*#__PURE__*/React.createElement(Tooltip, _extends({}, otherProps, {
    prefixCls: clsPrefix,
    ref: ref,
    overlay: getOverlay(clsPrefix),
    transitionName: getTransitionName("u", 'zoom-big', otherProps.transitionName)
  }));
});
Popover.displayName = 'Popover';
Popover.defaultProps = {
  placement: 'top',
  trigger: 'hover',
  mouseEnterDelay: 0.1,
  mouseLeaveDelay: 0.1,
  overlayStyle: {}
};
export default Popover;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-popover/src/index.js